import { inject } from '@angular/core';
import { CanDeactivateFn, Routes } from '@angular/router';

import { OverlayStackService } from './core/state/overlay-stack.service';

const closeOverlayBeforeRouteChange: CanDeactivateFn<unknown> = () => !inject(OverlayStackService).closeTop();

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/search-shell/search-shell.component').then((module) => module.SearchShellComponent),
    canDeactivate: [closeOverlayBeforeRouteChange],
  },
  {
    path: 'busca',
    loadComponent: () => import('./features/search-shell/search-shell.component').then((module) => module.SearchShellComponent),
    canDeactivate: [closeOverlayBeforeRouteChange],
  },
  {
    path: 'busca/resultados',
    loadComponent: () => import('./features/search-shell/search-shell.component').then((module) => module.SearchShellComponent),
    canDeactivate: [closeOverlayBeforeRouteChange],
  },
  {
    path: 'busca/prestador/:id',
    loadComponent: () => import('./features/provider-detail/provider-detail.component').then((module) => module.ProviderDetailComponent),
    canDeactivate: [closeOverlayBeforeRouteChange],
  },
  { path: '**', redirectTo: '' },
];
